export default __webpack_public_path__ + "static/media/cym.658e9d4a.mp3";